// Data freshness - how long before data is considered stale
export const CACHE_STALE_TIME = {
	DEFAULT: 0, // Immediately stale (React Query default)
	DIFF_DATA: 10 * 1000, // 10 seconds - diffs need frequent updates during deployment
	ENTITY_DETAILS_PAGES: 60 * 1000, // 60 seconds - individual entity details
	ENTITY_FILTER_OPTIONS: 5 * 60 * 1000, // 5 minutes - rarely changes
	ENTITY_METADATA: 5 * 60 * 1000, // 5 minutes - rarely changes
	ENTITY_TABLES: 30 * 1000, // 30 seconds - frequent updates expected
	EXPANSION_COUNTS: 60 * 1000, // 60 seconds - less frequent changes
	FIELD_CONFIG: 60 * 60 * 1000, // 1 hour - field configuration rarely changes
	LOCK_STATUS: Number.POSITIVE_INFINITY, // Never stale - subscription-driven
	PRODUCTION_DATA: 3 * 60 * 60 * 1000, // 3 hours - production data is stable
} as const

// Garbage collection - how long to keep data in cache after it's unused
export const CACHE_GC_TIME = {
	DEFAULT: 5 * 60 * 1000, // 5 minutes (React Query default)
	DIFF_DATA: 60 * 1000, // 1 minute - clear quickly after use
	ENTITY_DETAILS_PAGES: 30 * 60 * 1000, // 30 minutes - keep detail pages cached longer
	ENTITY_FILTER_OPTIONS: 10 * 60 * 1000, // 10 minutes
	ENTITY_METADATA: 10 * 60 * 1000, // 10 minutes
	ENTITY_TABLES: 30 * 60 * 1000, // 30 minutes
	FIELD_CONFIG: 2 * 60 * 60 * 1000, // 2 hours
	PRODUCTION_DATA: 3 * 60 * 60 * 1000, // 3 hours
} as const

export const CACHE_REFETCH = {
	ON_WINDOW_FOCUS: false, // Don't refetch on window focus for admin tables
	ON_RECONNECT: false, // Don't refetch on reconnect (let user manually refresh)
	RETRY: false, // Fail fast — no retries
	RETRY_DELAY: 0,
} as const

// Pagination defaults
export const PAGINATION = {
	DEFAULT_PAGE_SIZE: 50,
	PAGE_SIZE_OPTIONS: [10, 25, 50, 100] as const,
	MAX_PAGE_SIZE: 100,
} as const

// Search/filter debounce times
export const DEBOUNCE = {
	SEARCH: 300, // 300ms for search input
	FILTER: 0, // No debounce for filter changes (immediate)
} as const
